import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=3b85fdd6&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=3b85fdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85fdd6",
  null
  
)

export default component.exports